/**
 * Home con una categoría del hero ya marcada: `/piscinas`, `/jardines`, `/interiores`.
 *
 * Es la misma landing que `/` (mismo asset, mismo `loadData`); solo cambia qué botón del
 * buscador del hero sale marcado y, con él, a qué pestaña de búsqueda lleva. Los valores son
 * los ids de categoría de `CocopoolHeroSearch` (`listingTabs`).
 */
export const LANDING_CATEGORY_LISTING_TYPES = {
  piscinas: 'pool',
  jardines: 'garden',
  interiores: 'interiores',
};

/** Path de la ruta: las categorías van en lista blanca, cualquier otro `/x` sigue en el 404. */
export const landingCategoryRoutePath = () =>
  `/:category(${Object.keys(LANDING_CATEGORY_LISTING_TYPES).join('|')})`;

/** Id de categoría del hero para el slug de la URL, o `null` (ninguna marcada). */
export const listingTypeForLandingCategory = slug => LANDING_CATEGORY_LISTING_TYPES[slug] || null;

/** ¿Es la home, con o sin categoría? (el topbar va sobre el hero en las dos). */
export const isLandingRouteName = name => name === 'LandingPage' || name === 'LandingCategoryPage';
